/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import styles from '@app/components/ConnectionIssuesLinks.module.css';
import type {StatusPageIncident} from '@app/stores/StatusPageStore';
import {ExternalUrls} from '@fluxer/constants/src/ExternalUrls';
import {Trans} from '@lingui/react/macro';

interface ConnectionIssuesLinksProps {
	incident: StatusPageIncident | null;
	className?: string;
}

const STATUS_HISTORY_URL = `${ExternalUrls.SERVICE_STATUS}/history`;

export function ConnectionIssuesLinks({incident, className}: ConnectionIssuesLinksProps) {
	const containerClassName = className != null ? `${styles.container} ${className}` : styles.container;
	const incidentUrl = incident?.url ?? STATUS_HISTORY_URL;

	return (
		<div className={containerClassName}>
			<p className={styles.prompt}>
				<Trans>Connection issues?</Trans>
			</p>
			<p className={styles.links}>
				<a href={ExternalUrls.SERVICE_STATUS} target="_blank" rel="noopener noreferrer" className={styles.link}>
					<Trans>Status Page</Trans>
				</a>
				<span aria-hidden="true" className={styles.separator}>
					·
				</span>
				<a href={incidentUrl} target="_blank" rel="noopener noreferrer" className={styles.link}>
					{incident ? <Trans>Read Incident</Trans> : <Trans>Incident History</Trans>}
				</a>
			</p>
		</div>
	);
}
